import DOEIndianMoundData from "../../../../src/components/doe-indian-mound-data.js";
import * as React from 'react';
export default {
  DOEIndianMoundData,
  React
};